<template>

    <div class="site-wrap">
        <header class="fbs__net-navbar navbar navbar-expand-lg dark">
            <div class="container d-flex align-items-center justify-content-between">
                <a class="navbar-brand w-auto" href="/">
                    <img src="/assets/nuevos_logos/LOGO ASESORIAS DE RENTA - FINAL.png" alt="Asesorías de Renta" style="max-height: 220px; width: 200px; margin: -40px 0;">
                </a>

                <div class="offcanvas offcanvas-start w-75" id="fbs__net-navbars" tabindex="-1"
                    aria-labelledby="fbs__net-navbarsLabel">


                    <div class="offcanvas-header position-relative justify-content-center">
                        <div class="offcanvas-header-logo text-center">
                            <a class="logo-link mobile-link" id="fbs__net-navbarsLabel" href="/">
                                <img src="/assets/nuevos_logos/a0a94554-6865-4aba-b35e-f1ce45f963fb.png" alt="Asesorías de Renta" style="max-height: 110px; margin: -10px 0;">
                            </a>
                        </div>
                        <!-- Pinned to top-right corner with standard spacing -->
                        <button class="btn-close btn-close-black position-absolute top-0 end-0 m-3" type="button" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                    </div>

                    <div class="offcanvas-body align-items-lg-center">
                        <ul class="navbar-nav nav me-auto ps-lg-5 mb-2 mb-lg-0">
                            <li class="nav-item"><a class="nav-link scroll-link active" href="#inicio">Inicio</a></li>
                            <li class="nav-item"><a class="nav-link scroll-link" href="#quienes-somos">Quiénes Somos</a>
                            </li>
                            <li class="nav-item"><a class="nav-link scroll-link" href="#servicios">Servicios</a></li>
                            <li class="nav-item"><a class="nav-link scroll-link" href="#precios">Precios</a></li>
                            <li class="nav-item"><a class="nav-link scroll-link" href="#como-trabajamos">Cómo
                                    Trabajamos</a></li>
                            <li class="nav-item"><a class="nav-link scroll-link" href="#contacto">Contacto</a></li>
                            <li class="nav-item"><a class="nav-link scroll-link" href="#calculadora">Calculadora de Honorarios</a></li>
                            <li class="nav-item"><a class="nav-link scroll-link" href="/links">Links</a></li>
                        </ul>
                    </div>
                </div>

                <div class="ms-auto w-auto">


                    <div class="header-social d-flex align-items-center gap-1"><a class="btn btn-primary py-2"
                            href="#">Empieza ahora</a>

                        <button class="fbs__net-navbar-toggler justify-content-center align-items-center ms-auto"
                            data-bs-toggle="offcanvas" data-bs-target="#fbs__net-navbars"
                            aria-controls="fbs__net-navbars" aria-label="Toggle navigation" aria-expanded="false">
                            <svg class="fbs__net-icon-menu" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                viewbox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round">
                                <line x1="21" x2="3" y1="6" y2="6"></line>
                                <line x1="15" x2="3" y1="12" y2="12"></line>
                                <line x1="17" x2="3" y1="18" y2="18"></line>
                            </svg>
                            <svg class="fbs__net-icon-close" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                viewbox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round">
                                <path d="M18 6 6 18"></path>
                                <path d="m6 6 12 12"></path>
                            </svg>
                        </button>

                    </div>

                </div>
            </div>
        </header>

        <main>

            <!-- INICIO -->
            <section class="hero__v6 section" id="inicio">
                <div class="container mx-auto">

                    <div class="row justify-content-center">

                        <div class="col-lg-8 mb-4 mb-lg-0 text-center">

                            <span class="hero-subtitle text-uppercase" data-aos="fade-up" data-aos-delay="0">
                                Asesoría Tributaria
                            </span>

                            <h1 class="hero-title mb-3" data-aos="fade-up" data-aos-delay="100">
                                Asesoría Tributaria en Chile
                            </h1>

                            <p class="hero-description mb-4 mb-lg-5" data-aos="fade-up" data-aos-delay="200">
                                Especialistas en declaración de renta, contabilidad mensual, formalización de
                                empresas y trámites en el SII. Tu tranquilidad tributaria es nuestra prioridad. Asesoria online y presencial en La Serena.
                            </p>

                            <div class="cta d-flex justify-content-center gap-2 mb-4 mb-lg-5" data-aos="fade-up"
                                data-aos-delay="300">
                                <a class="btn" href="#contacto">Consulta Gratis</a>
                                <a class="btn btn-white-outline" href="#servicios">
                                    Ver Servicios
                                    <svg class="lucide lucide-arrow-up-right" xmlns="http://www.w3.org/2000/svg"
                                        width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                        <path d="M7 7h10v10"></path>
                                        <path d="M7 17 17 7"></path>
                                    </svg>
                                </a>
                            </div>

                            <div class="logos mb-4" data-aos="fade-up" data-aos-delay="400">
                                <span class="logos-title text-uppercase mb-4 d-block">Servicios principales</span>

                                <div class="service-icons d-flex justify-content-center gap-3 flex-wrap mt-3">
                                    <div class="service-item d-flex align-items-center gap-2 px-4 py-2 rounded-pill">
                                        <i class="bi bi-calculator fs-5" style="color: #783432;"></i>
                                        <span class="fw-medium text-dark" style="font-size: 0.9rem;">Declaración de Renta</span>
                                    </div>
                                    <div class="service-item d-flex align-items-center gap-2 px-4 py-2 rounded-pill">
                                        <i class="bi bi-graph-up fs-5" style="color: #783432;"></i>
                                        <span class="fw-medium text-dark" style="font-size: 0.9rem;">Contabilidad Mensual</span>
                                    </div>
                                    <div class="service-item d-flex align-items-center gap-2 px-4 py-2 rounded-pill">
                                        <i class="bi bi-building fs-5" style="color: #783432;"></i>
                                        <span class="fw-medium text-dark" style="font-size: 0.9rem;">Formalización</span>
                                    </div>
                                    <div class="service-item d-flex align-items-center gap-2 px-4 py-2 rounded-pill">
                                        <i class="bi bi-file-text fs-5" style="color: #783432;"></i>
                                        <span class="fw-medium text-dark" style="font-size: 0.9rem;">Trámites SII</span>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

            <!-- NOSOTROS -->
           <section class="about__v4 section" id="quienes-somos">
                <div class="container">
                    <div class="row align-items-center">

                        <div class="col-md-6 order-md-2">
                            <div class="row justify-content-end">
                                <div class="col-md-11 mb-4 mb-md-0 text-center">
                                    <span class="subtitle text-uppercase mb-3" data-aos="fade-up"
                                        data-aos-delay="0">Quiénes Somos</span>
                                    <h2 class="mb-4" data-aos="fade-up" data-aos-delay="100">
                                        Un equipo de asesores expertos en impuestos
                                    </h2>
                                    <div data-aos="fade-up" data-aos-delay="200">
                                        <p>
                                            En <strong>@asesoriasderenta</strong> creemos que un emprendedor informado
                                            toma mejores decisiones. Liderados por una <strong>Contadora Auditora
                                                titulada
                                                de la Universidad de La Serena</strong>, simplificamos el complejo mundo
                                            tributario con lenguaje claro y una asesoría verdaderamente personalizada.
                                        </p>
                                        <p>
                                            Somos tu aliado experto en la Región de Coquimbo y todo Chile para que tú te
                                            enfoques en crecer, mientras aseguramos que tu camino en el SII sea
                                            transparente, legal y libre de multas.
                                        </p>
                                    </div>
                                    <h4 class="small fw-bold mt-4 mb-3" data-aos="fade-up" data-aos-delay="300">
                                        Nuestros Pilares y Compromiso
                                    </h4>
                                    <ul class="d-flex flex-row flex-wrap list-unstyled gap-3 features align-content-center justify-content-center"
                                        data-aos="fade-up" data-aos-delay="400">
                                        <li class="d-flex align-items-center gap-2">
                                            <span class="icon rounded-circle text-center">
                                                <i class="bi bi-check"></i>
                                            </span>
                                            <span class="text">Educación Tributaria</span>
                                        </li>
                                        <li class="d-flex align-items-center gap-2">
                                            <span class="icon rounded-circle text-center">
                                                <i class="bi bi-check"></i>
                                            </span>
                                            <span class="text">Asesoría Personalizada</span>
                                        </li>
                                        <li class="d-flex align-items-center gap-2">
                                            <span class="icon rounded-circle text-center">
                                                <i class="bi bi-check"></i>
                                            </span>
                                            <span class="text">Claridad y Cercanía</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-6">
                            <div class="hero-img">
                                <img class="img-main img-fluid rounded-4 object-fit-cover" loading="lazy"
                                    src="assets/images/contabilidad-21.jpeg" alt="Equipo contador profesional">
                            </div>
                        </div>

                    </div>
                </div>
            </section>
            <!-- SERVICIOS -->
            <section class="section features__v2" id="servicios">
                <div class="container">
                    <div class="row mb-5">
                        <div class="col-md-6 mx-auto text-center">
                            <span class="subtitle text-uppercase mb-3" data-aos="fade-up"
                                data-aos-delay="0">Servicios</span>
                            <h2 class="mb-3" data-aos="fade-up" data-aos-delay="100">
                                Servicios Contables para Emprendedores en Chile
                            </h2>
                            <p data-aos="fade-up" data-aos-delay="200">Ofrecemos soluciones completas para todas tus
                                necesidades legales y tributarias</p>
                        </div>
                    </div>
                    <div class="row">
                       <div class="col-md-6 col-lg-3 mb-4" data-aos="fade-up" data-aos-delay="0">
                            <div class="service-card text-center p-4 h-100">
                                <div class="icon-wrapper mx-auto mb-4">
                                    <div class="icon-badge"></div>
                                    <i class="bi bi-calculator icon-main"></i>
                                </div>
                                <h3 class="fs-5 fw-bold mb-3">Declaración de Renta</h3>
                                <p>Asesoría personalizada para tu declaración anual. Maximizamos tus devoluciones y
                                    evitamos multas del SII.</p>
                            </div>
                        </div>

                        <div class="col-md-6 col-lg-3 mb-4" data-aos="fade-up" data-aos-delay="100">
                            <div class="service-card text-center p-4 h-100">
                                <div class="icon-wrapper mx-auto mb-4">
                                    <div class="icon-badge"></div>
                                    <i class="bi bi-graph-up icon-main"></i>
                                </div>
                                <h3 class="fs-5 fw-bold mb-3">Contabilidad Mensual</h3>
                                <p>Llevamos tu contabilidad al día con informes mensuales detallados y cumplimiento de
                                    todas las obligaciones.</p>
                            </div>
                        </div>

                        <div class="col-md-6 col-lg-3 mb-4" data-aos="fade-up" data-aos-delay="200">
                            <div class="service-card text-center p-4 h-100">
                                <div class="icon-wrapper mx-auto mb-4">
                                    <div class="icon-badge"></div>
                                    <i class="bi bi-building icon-main"></i>
                                </div>
                                <h3 class="fs-5 fw-bold mb-3">Formaliza tu Emprendimiento</h3>
                                <p>Te ayudamos a constituir tu empresa, elegir el tipo societario adecuado y realizar
                                    todos los trámites necesarios.</p>
                            </div>
                        </div>

                        <div class="col-md-6 col-lg-3 mb-4" data-aos="fade-up" data-aos-delay="300">
                           <div
                                class="service-card p-4 rounded-4 h-100 d-flex flex-column justify-content-between gap-5 text-center">
                                <div class="d-flex flex-column align-items-center">

                                    <div class="icon-wrapper mb-4">
                                        <div class="icon-badge"></div>
                                        <i class="bi bi-file-earmark-text icon-main"></i>
                                    </div>

                                    <h3 class="fs-5 fw-bold mb-3">Asesoria legal y tributaria</h3>
                                    <p class="mb-4">
                                        Te brindamos asesoramiento en conjunto con un asesor legal para cumplir con toda la normativa legal y tributaria.
                                    </p>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <!-- PRECIOS -->
            <section class="section pricing__v2" id="precios">
                <div class="container">
                    <div class="row mb-5">
                        <div class="col-md-5 mx-auto text-center">
                            <span class="subtitle text-uppercase mb-3" data-aos="fade-up"
                                data-aos-delay="0">Precios</span>
                            <h2 class="mb-3" data-aos="fade-up" data-aos-delay="100">Planes para cada necesidad</h2>
                            <p data-aos="fade-up" data-aos-delay="200">Elige el plan que mejor se adapte a tu negocio
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4 mb-4 mb-md-0" data-aos="fade-up" data-aos-delay="300">
                            <div class="p-5 rounded-4 price-table h-100">
                                <h3>Asesoría general</h3>
                                <p>Perfecto para trabajadores independientes y personas naturales</p>
                                <div class="price mb-4"><strong>25.000 clp</strong><span>/ Pago único</span></div>
                                <ul class="list-unstyled mb-4">
                                    <li><i class="bi bi-check-circle-fill me-2" style="color: #783432;"></i> <strong>Declaración Renta (F22)</strong></li>
                                    <li><i class="bi bi-check-circle-fill me-2" style="color: #783432;"></i> Revisión de documentos</li>
                                    <li><i class="bi bi-check-circle-fill me-2" style="color: #783432;"></i> Online</li>
                                    <li><i class="bi bi-check-circle-fill me-2" style="color: #783432;"></i> Impuesto incluido</li>
                                </ul>
                                <div><a class="btn" href="https://mpago.la/2rdKq3q" target="_blank"
                                        rel="noopener">Contratar</a></div>
                            </div>
                        </div>

                        <div class="col-md-4 mb-4 mb-md-0" data-aos="fade-up" data-aos-delay="400">
                            <div class="p-5 rounded-4 price-table popular h-100">
                                <div class="popular-badge">Más Popular</div>
                                <h3>Formalización empresa</h3>
                                <p>¡Oferta de lanzamiento solo por este mes!</p>
                                <div class="price mb-2"><strong><span style="text-decoration: line-through;">120.000
                                            clp</span> 75.000 clp</strong><span>/ Pago único</span></div>
                                <ul class="list-unstyled mb-4">
                                    <li><i class="bi bi-check-circle-fill me-2" style="color: #e8ceae;"></i> Constitución de la sociedad</li>
                                    <li><i class="bi bi-check-circle-fill me-2" style="color: #e8ceae;"></i> Inicio de actividades</li>
                                    <li><i class="bi bi-check-circle-fill me-2" style="color: #e8ceae;"></i> Instalación certificado digital</li>
                                    <li><i class="bi bi-check-circle-fill me-2" style="color: #e8ceae;"></i> Tramite Online</li>
                                    <li><i class="bi bi-check-circle-fill me-2" style="color: #e8ceae;"></i> Impuesto incluido</li>
                                </ul>
                                <div><a class="btn btn-white hover-outline" href="https://mpago.la/2v7PNKh"
                                        target="_blank" rel="noopener">Contratar</a></div>
                            </div>
                        </div>

                        <div class="col-md-4" data-aos="fade-up" data-aos-delay="500">
                            <div class="p-5 rounded-4 price-table h-100">
                                <h3>Término de Giro</h3>
                                <p>Cierre de Empresa (Sin Movimientos)</p>
                                <div class="price mb-4"><span>Desde </span><strong>120.000 clp</strong></div>
                                <ul class="list-unstyled mb-4">
                                    <li><i class="bi bi-check-circle-fill me-2" style="color: #783432;"></i> Revisión de deudas y multas</li>
                                    <li><i class="bi bi-check-circle-fill me-2" style="color: #783432;"></i> Anulación de folios</li>
                                    <li><i class="bi bi-check-circle-fill me-2" style="color: #783432;"></i> Formulario 2121</li>
                                    <li><i class="bi bi-check-circle-fill me-2" style="color: #783432;"></i> Obtención de Certificado TG</li>
                                    <li><i class="bi bi-check-circle-fill me-2" style="color: #783432;"></i> Impuesto incluido</li>
                                </ul>
                                <div><a class="btn" href="https://mpago.la/2cB4DaW" target="_blank"
                                        rel="noopener">Contratar</a></div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <!-- COMO TRABAJAMOS -->
            <section class="section howitworks__v1" id="como-trabajamos">
                <div class="container">
                    <div class="row mb-5">
                        <div class="col-md-6 text-center mx-auto">
                            <span class="subtitle text-uppercase mb-3" data-aos="fade-up" data-aos-delay="0">Cómo
                                Trabajamos</span>
                            <h2 data-aos="fade-up" data-aos-delay="100">Nuestro Proceso de Trabajo</h2>
                            <p data-aos="fade-up" data-aos-delay="200">
                                Hemos diseñado un proceso simple y eficiente para brindarte la mejor asesoría contable y
                                tributaria.
                                Sigue estos pasos para comenzar:
                            </p>
                        </div>
                    </div>
                    <div class="row g-md-5">
                        <div class="col-md-6 col-lg-3">
                            <div class="step-card text-center h-100 d-flex flex-column justify-content-start position-relative"
                                data-aos="fade-up" data-aos-delay="0">
                                <div data-aos="fade-right" data-aos-delay="500">
                                    <img class="arch-line" loading="lazy" src="assets/images/arch-line.svg"
                                        alt="Línea de conexión">
                                </div>
                                <span class="step-number rounded-circle text-center fw-bold mb-5 mx-auto">1</span>
                                <div>
                                    <h3 class="fs-5 mb-4"><i class="bi bi-telephone-fill me-2" style="color: #783432;"></i> Consulta Inicial</h3>
                                    <p>
                                        Contáctanos por teléfono, WhatsApp o correo. Analizamos tu situación actual y
                                        identificamos tus necesidades específicas sin costo alguno.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-6 col-lg-3" data-aos="fade-up" data-aos-delay="600">
                            <div
                                class="step-card reverse text-center h-100 d-flex flex-column justify-content-start position-relative">
                                <div data-aos="fade-right" data-aos-delay="1100">
                                    <img class="arch-line reverse" loading="lazy"
                                        src="assets/images/arch-line-reverse.svg" alt="Línea de conexión">
                                </div>
                                <span class="step-number rounded-circle text-center fw-bold mb-5 mx-auto">2</span>
                                <h3 class="fs-5 mb-4"><i class="bi bi-clipboard2-check-fill me-2" style="color: #783432;"></i> Recopilación de Información</h3>
                                <p>
                                    Solicitamos y organizamos toda la documentación necesaria. Te guiamos paso a paso
                                    sobre qué documentos necesitas según tu caso.
                                </p>
                            </div>
                        </div>

                        <div class="col-md-6 col-lg-3" data-aos="fade-up" data-aos-delay="1200">
                            <div
                                class="step-card text-center h-100 d-flex flex-column justify-content-start position-relative">
                                <div data-aos="fade-right" data-aos-delay="1700">
                                    <img class="arch-line" loading="lazy" src="assets/images/arch-line.svg"
                                        alt="Línea de conexión">
                                </div>
                                <span class="step-number rounded-circle text-center fw-bold mb-5 mx-auto">3</span>
                                <h3 class="fs-5 mb-4"><i class="bi bi-gear-fill me-2" style="color: #783432;"></i> Procesamiento y Análisis</h3>
                                <p>
                                    Nuestro equipo de expertos procesa tu información, prepara las declaraciones
                                    y optimiza tu situación tributaria para maximizar beneficios.
                                </p>
                            </div>
                        </div>

                        <div class="col-md-6 col-lg-3" data-aos="fade-up" data-aos-delay="1800">
                            <div
                                class="step-card last text-center h-100 d-flex flex-column justify-content-start position-relative">
                                <span class="step-number rounded-circle text-center fw-bold mb-5 mx-auto">4</span>
                                <div>
                                    <h3 class="fs-5 mb-4"><i class="bi bi-check-circle-fill me-2" style="color: #783432;"></i> Entrega y Seguimiento</h3>
                                    <p>
                                        Te entregamos todos los documentos listos y realizamos el seguimiento necesario.
                                        Mantenemos contacto para futuras asesorías y actualizaciones.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- NUESTRAS GARANTIAS -->
                    <div class="row mt-5 pt-5">
                        <div class="col-12">
                            <div class="guarantee-section text-center p-4 rounded-4 bg-light">
                                <h3 class="mb-4" data-aos="fade-up" data-aos-delay="0">Nuestras Garantías</h3>
                                <div class="row">
                                    <div class="col-md-4 mb-3" data-aos="fade-up" data-aos-delay="100">
                                        <div class="guarantee-item">
                                            <i class="bi bi-shield-check fs-1 text-success mb-3"></i>
                                            <h5>100% Legal</h5>
                                            <p class="mb-0">Todos nuestros procesos cumplen con la normativa del
                                                servicio de impuestos internos y la legislación laboral</p>
                                        </div>
                                    </div>
                                    <div class="col-md-4 mb-3" data-aos="fade-up" data-aos-delay="200">
                                        <div class="guarantee-item">
                                            <i class="bi bi-clock fs-1 text-primary mb-3"></i>
                                            <h5>Puntualidad</h5>
                                            <p class="mb-0">Cumplimos con todos los plazos establecidos</p>
                                        </div>
                                    </div>
                                    <div class="col-md-4 mb-3" data-aos="fade-up" data-aos-delay="300">
                                        <div class="guarantee-item">
                                            <i class="bi bi-headset fs-1 text-info mb-3"></i>
                                            <h5>Soporte Continuo</h5>
                                            <p class="mb-0">Te acompañamos durante todo el proceso</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <!-- SERVICIOS -->
            <section class="section services__v3" id="servicios2">
                <div class="container">
                    <div class="row mb-5">
                        <div class="col-md-8 mx-auto text-center">
                            <span class="subtitle text-uppercase mb-3" data-aos="fade-up" data-aos-delay="0">Nuestros
                                Servicios</span>
                            <h2 class="mb-3" data-aos="fade-up" data-aos-delay="100">
                                Servicios Profesionales para Tu Tranquilidad</h2>
                        </div>
                    </div>
                    <div class="row g-4">
                        <div class="col-md-6 col-lg-4" data-aos="fade-up" data-aos-delay="0">
                            <div class="service-card p-4 rounded-4 h-100 d-flex flex-column justify-content-between gap-5">
                                <div>
                                    <span class="icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" version="1.1"
                                            xmlns:xlink="http://www.w3.org/1999/xlink" x="0" y="0" viewbox="0 0 64 64"
                                            style="enable-background:new 0 0 512 512" xml:space="preserve">
                                            <g>
                                                <path
                                                    d="M49.5 4H24.34a6.007 6.007 0 0 0-6 6v5.29a1 1 0 0 0 2 0V10a4.005 4.005 0 0 1 4-4h3.218l1.237 3.066a3.984 3.984 0 0 0 3.71 2.503h8.826a3.984 3.984 0 0 0 3.71-2.503L46.277 6H49.5a4.004 4.004 0 0 1 4 4v44a4.004 4.004 0 0 1-4 4H24.34a4.005 4.005 0 0 1-4-4V39.42h11.8a6.774 6.774 0 0 0 12.998 2.159 1 1 0 0 0-1.842-.78 4.778 4.778 0 1 1-2.638-6.3 1 1 0 0 0 1.298-.56c.446-1.634-1.965-1.701-3.062-1.776a6.785 6.785 0 0 0-6.6 5.257H13.502a3.003 3.003 0 0 1-3-3v-7.932h27.4v2.672a1 1 0 0 0 2 0v-5.87a5.006 5.006 0 0 0-5-5H13.5a5.006 5.006 0 0 0-5 5c.007 1.424-.005 9.521 0 11.13a5.006 5.006 0 0 0 5 5h4.84V54a6.007 6.007 0 0 0 6 6H49.5a6.007 6.007 0 0 0 6-6V10a6.007 6.007 0 0 0-6-6zm-6.314 4.317a1.994 1.994 0 0 1-1.855 1.252h-8.827a1.992 1.992 0 0 1-1.854-1.252l-.934-2.312H44.12zM10.501 23.29a3.003 3.003 0 0 1 3-3h21.4a3.003 3.003 0 0 1 3 3v1.198H10.5z"
                                                    fill="currentColor" opacity="1" data-original="#000000"></path>
                                            </g>
                                        </svg>
                                    </span>
                                    <h3 class="fs-5 mb-3">Declaración de Renta</h3>
                                    <p class="mb-4">
                                        Te ayudamos con tu declaración de renta anual, asegurando el cumplimiento de
                                        todas las obligaciones tributarias y maximizando tus beneficios fiscales. Además
                                        te explicamos tu F22 para que comprendas por qué debes pagar impuesto o
                                        solicitar devolución.
                                    </p>
                                </div>
                                <a class="special-link d-inline-flex gap-2 align-items-center text-decoration-none"
                                    href="#precios">
                                    <span class="icons">
                                        <i class="icon-1 bi bi-arrow-right-short"></i>
                                        <i class="icon-2 bi bi-arrow-right-short"></i>
                                    </span>
                                    <span>Más información</span>
                                </a>
                            </div>
                        </div>

                        <div class="col-md-6 col-lg-4" data-aos="fade-up" data-aos-delay="200">
                            <div
                                class="service-card p-4 rounded-4 h-100 d-flex flex-column justify-content-between gap-5">
                                <div>
                                    <span class="icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" version="1.1"
                                            xmlns:xlink="http://www.w3.org/1999/xlink" x="0" y="0" viewbox="0 0 64 64"
                                            style="enable-background:new 0 0 512 512" xml:space="preserve">
                                            <g>
                                                <path
                                                    d="M59 47.487h-1.81v-27.61a5.223 5.223 0 0 0-5-5.409h-3.71a1 1 0 0 0 0 2h3.71a3.228 3.228 0 0 1 3 3.41v27.609H26.03a1.013 1.013 0 0 0-.996 1.02 34.358 34.358 0 0 0 1.49 3.57 2 2 0 0 0 1.828 1.188h7.296a2 2 0 0 0 1.828-1.188l1.149-2.589L58 49.487v2.74a2.823 2.823 0 0 1-2.82 2.82H8.82A2.823 2.823 0 0 1 6 52.227v-2.74h16.03a1 1 0 0 0 0-2H8.81v-27.61a3.228 3.228 0 0 1 3-3.41h6.89c-3.535 9.154 3.658 19.594 13.63 19.48 11.076.08 18.127-12.336 12.587-21.706a14.54 14.54 0 0 0-25.162-.073 1.646 1.646 0 0 1-.163.299H11.81a5.223 5.223 0 0 0-5 5.41v27.61H5a1 1 0 0 0-1 1v3.74a4.825 4.825 0 0 0 4.82 4.82h46.36a4.825 4.825 0 0 0 4.82-4.82v-3.74a1 1 0 0 0-1-1z"
                                                    fill="currentColor" opacity="1" data-original="#000000"></path>
                                            </g>
                                        </svg>
                                    </span>
                                    <h3 class="fs-5 mb-3">Formulario 29 Mensual</h3>
                                    <p class="mb-4">
                                        Enviamos tus F29 para cumplir con tus obligaciones mensuales, otorgando un
                                        reporte detallado del control de gastos e ingresos, y análisis financiero para
                                        optimizar tu negocio.
                                    </p>
                                </div>
                                <a class="special-link d-inline-flex gap-2 align-items-center text-decoration-none"
                                    href="#precios">
                                    <span class="icons">
                                        <i class="icon-1 bi bi-arrow-right-short"></i>
                                        <i class="icon-2 bi bi-arrow-right-short"></i>
                                    </span>
                                    <span>Más información</span>
                                </a>
                            </div>
                        </div>

                        <div class="col-md-6 col-lg-4" data-aos="fade-up" data-aos-delay="300">
                            <div class="service-card p-4 rounded-4 h-100 d-flex flex-column justify-content-between gap-5">
                                <div>
                                    <span class="icon">
                                        <!-- Corporate constitution deed with verified tax seal matching the original 64x64 viewBox geometry -->
                                        <svg xmlns="http://www.w3.org/2000/svg" version="1.1"
                                            xmlns:xlink="http://www.w3.org/1999/xlink" x="0" y="0" viewbox="0 0 64 64"
                                            style="enable-background:new 0 0 512 512" xml:space="preserve">
                                            <g>
                                                <path
                                                    d="M38 4H16a4 4 0 0 0-4 4v32a4 4 0 0 0 4 4h14a1 1 0 0 0 0-2H16a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h21v9a3 3 0 0 0 3 3h9v8a1 1 0 0 0 2 0V17a2 2 0 0 0-.586-1.414l-11-11A2 2 0 0 0 38 4Zm1 3.414L46.586 15H40a1 1 0 0 1-1-1ZM20 16h10a1 1 0 0 0 0-2H20a1 1 0 0 0 0 2Zm12 5H20a1 1 0 0 0 0 2h12a1 1 0 0 0 0-2Zm-12 7h8a1 1 0 0 0 0-2h-8a1 1 0 0 0 0 2Zm24 0a10 10 0 1 0 10 10 10.011 10.011 0 0 0-10-10Zm0 18a8 8 0 1 1 8-8 8.009 8.009 0 0 1-8 8Zm3.707-10.707a1 1 0 0 0-1.414 0L42 39.586l-2.293-2.293a1 1 0 0 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0l5-5a1 1 0 0 0 0-1.414Z"
                                                    fill="currentColor" opacity="1" data-original="#000000"></path>
                                            </g>
                                        </svg>
                                    </span>
                                    <h3 class="fs-5 mb-3">Formalización de Empresas</h3>
                                    <p class="mb-4">
                                        Te acompañamos en todo el proceso de constitución de tu empresa, desde la
                                        elección del tipo de sociedad hasta el Inicio de actividades ante el SII y
                                        Verificación de actividad para emitir facturas.
                                    </p>
                                </div>
                                <a class="special-link d-inline-flex gap-2 align-items-center text-decoration-none"
                                    href="#precios">
                                    <span class="icons">
                                        <i class="icon-1 bi bi-arrow-right-short"></i>
                                        <i class="icon-2 bi bi-arrow-right-short"></i>
                                    </span>
                                    <span>Más información</span>
                                </a>
                            </div>
                        </div>

                        <div class="col-md-6 col-lg-4" data-aos="fade-up" data-aos-delay="400">
                            <div
                                class="service-card p-4 rounded-4 h-100 d-flex flex-column justify-content-between gap-5">
                                <div>
                                    <span class="icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" version="1.1"
                                            xmlns:xlink="http://www.w3.org/1999/xlink" x="0" y="0" viewbox="0 0 64 64"
                                            style="enable-background:new 0 0 512 512" xml:space="preserve">
                                            <g>
                                                <path
                                                    d="m57.936 58.647-4.47-11.871a9.542 9.542 0 0 0-5.914-5.693l-7.659-2.609-1.944-2.116v-2.62a13.043 13.043 0 0 0 4.739-5.175 14.256 14.256 0 0 0 3.237.14 2.909 2.909 0 0 0 2.905-2.906v-5.382a2.895 2.895 0 0 0-1.495-2.523 13.84 13.84 0 0 0-2.807-7.777 1 1 0 0 0-1.597 1.205 11.879 11.879 0 0 1 2.386 6.19c-.012-.01-2.017.036-1.987-.023-4.064-11.113-18.668-11.126-22.702.024h-1.875c.73-9.938 13.556-14.987 21.539-8.81a1 1 0 0 0 1.196-1.605c-9.394-7.24-24.311-1.02-24.754 10.758a2.895 2.895 0 0 0-1.566 2.561v5.382a2.909 2.909 0 0 0 2.905 2.906c.4-.042 2.932.115 3.213-.122a12.843 12.843 0 0 0 4.542 5.038v2.757l-1.825 2.184-7.553 2.521a9.547 9.547 0 0 0-5.917 5.695l-4.47 11.871a1.008 1.008 0 0 0 .935 1.352H49.97a1 1 0 0 0 0-2H36.123l-2.985-7.876 2.014-2.491 2.009 1.746a1.007 1.007 0 0 0 1.643-.594l1.322-8.118 6.785 2.312a7.549 7.549 0 0 1 4.682 4.504L55.555 58H53.97a1 1 0 0 0 0 2H57a1.007 1.007 0 0 0 .936-1.353z"
                                                    fill="currentColor" opacity="1" data-original="currentColor"></path>
                                            </g>
                                        </svg>
                                    </span>
                                    <h3 class="fs-5 mb-3">Asesoría Personalizada</h3>
                                    <p class="mb-4">Evita multas y errores con nuestro acompañamiento profesional. Te
                                        asesoramos en todas tus decisiones financieras y tributarias.</p>
                                </div>
                                <a class="special-link d-inline-flex gap-2 align-items-center text-decoration-none"
                                    href="#precios">
                                    <span class="icons">
                                        <i class="icon-1 bi bi-arrow-right-short"></i>
                                        <i class="icon-2 bi bi-arrow-right-short"></i>
                                    </span>
                                    <span>Más información</span>
                                </a>
                            </div>
                        </div>

                        <div class="col-md-6 col-lg-4" data-aos="fade-up" data-aos-delay="500">
                            <div class="service-card p-4 rounded-4 h-100 d-flex flex-column justify-content-between gap-5">
                                <div>
                                    <span class="icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" version="1.1"
                                            xmlns:xlink="http://www.w3.org/1999/xlink" x="0" y="0" viewbox="0 0 64 64"
                                            style="enable-background:new 0 0 512 512" xml:space="preserve">
                                            <g>
                                                <path
                                                    d="M35.719 21.413a1 1 0 0 0-1.586 1.218 15.554 15.554 0 0 1 1.806 3.012h-6.1a19.93 19.93 0 0 0-3.417-8.42 15.637 15.637 0 0 1 5.012 2.652 1 1 0 0 0 1.245-1.565 17.676 17.676 0 1 0-11.002 31.51c14.511.067 22.936-16.94 14.042-28.407z"
                                                    fill="currentColor" opacity="1" data-original="#000000"></path>
                                            </g>
                                        </svg>
                                    </span>
                                    <h3 class="fs-5 mb-3">Trámites en el SII</h3>
                                    <p class="mb-4">
                                        Realizamos todos tus trámites ante el Servicio de Impuestos Internos: Inicio de
                                        actividades, modificación de datos, obtención de certificados y más.
                                    </p>
                                </div>
                                <a class="special-link d-inline-flex gap-2 align-items-center text-decoration-none"
                                    href="#precios">
                                    <span class="icons">
                                        <i class="icon-1 bi bi-arrow-right-short"></i>
                                        <i class="icon-2 bi bi-arrow-right-short"></i>
                                    </span>
                                    <span>Más información</span>
                                </a>
                            </div>
                        </div>

                        <div class="col-md-6 col-lg-4" data-aos="fade-up" data-aos-delay="600">
                            <div class="service-card p-4 rounded-4 h-100 d-flex flex-column justify-content-between gap-5">
                                <div>
                                    <span class="icon">
                                        <!-- Business closure / tax termination deed with lock seal matching 64x64 viewBox geometry -->
                                        <svg xmlns="http://www.w3.org/2000/svg" version="1.1"
                                            xmlns:xlink="http://www.w3.org/1999/xlink" x="0" y="0" viewbox="0 0 64 64"
                                            style="enable-background:new 0 0 512 512" xml:space="preserve">
                                            <g>
                                                <path
                                                    d="M38 4H16a4 4 0 0 0-4 4v32a4 4 0 0 0 4 4h14a1 1 0 0 0 0-2H16a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h21v9a3 3 0 0 0 3 3h9v8a1 1 0 0 0 2 0V17a2 2 0 0 0-.586-1.414l-11-11A2 2 0 0 0 38 4Zm1 3.414L46.586 15H40a1 1 0 0 1-1-1ZM20 16h10a1 1 0 0 0 0-2H20a1 1 0 0 0 0 2Zm12 5H20a1 1 0 0 0 0 2h12a1 1 0 0 0 0-2Zm-12 7h8a1 1 0 0 0 0-2h-8a1 1 0 0 0 0 2ZM38 34v-6a5 5 0 0 1 10 0v6h2v-6a7 7 0 0 0-14 0v6h2Zm-1-1h12a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H37a3 3 0 0 1-3-3v-8a3 3 0 0 1 3-3Zm5 5v4h2v-4h-2Z"
                                                    fill="currentColor" opacity="1" data-original="#000000"></path>
                                            </g>
                                        </svg>
                                    </span>
                                    <h3 class="fs-5 mb-3">Término de Giro</h3>
                                    <p class="mb-4">Te ayudamos con el proceso de término de giro de tu empresa,
                                        cumpliendo con todas las obligaciones legales y tributarias correspondientes.
                                    </p>
                                </div>
                                <a class="special-link d-inline-flex gap-2 align-items-center text-decoration-none"
                                    href="#precios">
                                    <span class="icons">
                                        <i class="icon-1 bi bi-arrow-right-short"></i>
                                        <i class="icon-2 bi bi-arrow-right-short"></i>
                                    </span>
                                    <span>Más información</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- Servicios -->

            <!-- Calculadora de Honorarios -->
           <section class="section services__v3" id="calculadora">
                <div class="container">

                    <div class="row mb-4">
                        <div class="col-12 d-flex justify-content-center align-items-center gap-3">
                            <div class="btn-group p-1 bg-light rounded-pill shadow-sm gap-2" role="group">
                                <button type="button" @click="activeTab = 'honorarios'"
                                    :class="['btn rounded-pill px-4', activeTab === 'honorarios' ? 'btn-primary shadow' : 'btn-light']">
                                    Honorarios
                                </button>
                                <button type="button" @click="activeTab = 'iva'"
                                    :class="['btn rounded-pill px-4', activeTab === 'iva' ? 'btn-primary shadow' : 'btn-light']">
                                    Calculadora IVA
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="row mb-5 text-center">
                        <div class="col-md-8 mx-auto">
                            <h2 class="mb-3">
                                {{ activeTab === 'honorarios' ? 'Calculadora de Honorarios' : 'Calculadora de IVA (19%)'
                                }}
                            </h2>
                            <p >
                                {{ activeTab === 'honorarios'
                                    ? 'Cálculo automático de retención SII para boletas de honorarios.'
                                    : 'Calcula el IVA (19%) de forma rápida, ya sea desglosando o sumando el impuesto.'
                                }}
                            </p>
                        </div>
                    </div>

                    <div class="row justify-content-center">
                        <div class="col-lg-4 mb-4">
                            <div class="card shadow-sm border-0 h-100">
                                <div class="card-body p-4">
                                    <div class="mb-4">
                                        <label class="form-label fw-bold">Monto en Pesos</label>
                                        <input type="number" v-model="calcAmount" class="form-control form-control-lg"
                                            placeholder="Ej: 100000">
                                    </div>

                                    <div v-if="activeTab === 'honorarios'" class="mb-4">
                                        <label class="form-label fw-bold">Año de Retención</label>
                                        <select v-model="calcYear" class="form-select">
                                            <option :value="0.17">2028 (17%)</option>
                                            <option :value="0.16">2027 (16%)</option>
                                            <option :value="0.1525">2026 (15.25%)</option>
                                            <option :value="0.145">2025 (14.5%)</option>
                                        </select>
                                    </div>

                                    <div class="alert alert-info d-flex align-items-start mb-0" role="alert">
                                        <i class="bi bi-info-circle-fill fs-5 me-3 text-info"></i>
                                        <div>
                                            <p class="mb-0 small">En <strong>2027</strong> la retención será del <strong>16%</strong> y en <strong>2028</strong> alcanzará el <strong>17%</strong>.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-8 mb-4">
                            <div class="card shadow border-primary h-100 bg-white" style="border-width: 2px;">
                                <div class="card-body p-4 p-md-5">

                                    <div v-if="activeTab === 'honorarios'" class="row g-4">
                                        <div class="col-md-6 border-end-md">
                                            <h4 class="fw-bold text-primary">Líquido</h4>
                                            <p class="small  mb-4">Monto ingresado es lo que recibes.</p>
                                            <div class="mb-2"><small class="">Bruto:</small><br><strong>{{
                                                    formatCurrency(h_liq_bruto) }}</strong></div>
                                            <div class="mb-2"><small class="">Retención
                                                    ({{ (calcYear * 100).toFixed(2) }}%):</small><br><span
                                                    class="text-danger">{{ formatCurrency(h_liq_retencion) }}</span>
                                            </div>
                                            <div class="pt-2 border-top"><small
                                                    class="">Recibes:</small><br><span
                                                    class="fs-4 fw-bold text-success">{{ formatCurrency(amountNum)
                                                    }}</span></div>
                                        </div>
                                        <div class="col-md-6 ps-md-4">
                                            <h4 class="fw-bold text-primary">Bruto</h4>
                                            <p class="small  mb-4">Monto ingresado es el total de la boleta.
                                            </p>
                                            <div class="mb-2"><small class="">Bruto:</small><br><strong>{{
                                                    formatCurrency(amountNum) }}</strong></div>
                                            <div class="mb-2"><small class="">Retención
                                                    ({{ (calcYear * 100).toFixed(2) }}%):</small><br><span
                                                    class="text-danger">{{ formatCurrency(h_bru_retencion) }}</span>
                                            </div>
                                            <div class="pt-2 border-top"><small
                                                    class="">Recibes:</small><br><span
                                                    class="fs-4 fw-bold text-success">{{ formatCurrency(h_bru_neto)
                                                    }}</span></div>
                                        </div>
                                    </div>

                                    <div v-else class="row g-4">
                                        <div class="col-md-6 border-end-md">
                                            <h4 class="fw-bold text-primary">Monto Neto</h4>
                                            <p class="small  mb-4">Se le suma el 19% de IVA al monto.</p>
                                            <div class="mb-2"><small class="">Neto:</small><br><strong>{{
                                                    formatCurrency(amountNum) }}</strong></div>
                                            <div class="mb-2"><small class="">IVA (19%):</small><br><span
                                                    class="text-primary">+ {{ formatCurrency(iva_net_iva) }}</span>
                                            </div>
                                            <div class="pt-2 border-top"><small
                                                    class="">Total:</small><br><span
                                                    class="fs-4 fw-bold text-success">{{ formatCurrency(iva_net_total)
                                                    }}</span></div>
                                        </div>
                                        <div class="col-md-6 ps-md-4">
                                            <h4 class="fw-bold text-primary">IVA Incluido</h4>
                                            <p class="small  mb-4">Se desglosa el IVA del total.</p>
                                            <div class="mb-2"><small class="">Total:</small><br><strong>{{
                                                    formatCurrency(amountNum) }}</strong></div>
                                            <div class="mb-2"><small class="">IVA desglosado:</small><br><span
                                                    class="text-primary">{{ formatCurrency(iva_inc_iva) }}</span></div>
                                            <div class="pt-2 border-top"><small
                                                    class="">Neto:</small><br><span
                                                    class="fs-4 fw-bold text-success">{{ formatCurrency(iva_inc_neto)
                                                    }}</span></div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- Calculadora de Honorarios -->

            <!-- FAQ -->
            <section class="section faq__v2" id="faq">
                <div class="container">
                    <div class="row mb-4">
                        <div class="col-md-6 col-lg-7 mx-auto text-center">
                            <span class="subtitle text-uppercase mb-3" data-aos="fade-up" data-aos-delay="0">FAQ</span>
                            <h2 class="h2 fw-bold mb-3" data-aos="fade-up" data-aos-delay="0">Preguntas Frecuentes</h2>
                            <p data-aos="fade-up" data-aos-delay="100">Resolvemos las dudas más comunes sobre nuestros
                                servicios</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-8 mx-auto" data-aos="fade-up" data-aos-delay="150">
                            <div class="accordion custom-accordion" id="accordionFAQ">
                                <div class="accordion-item">
                                    <h2 class="accordion-header">
                                        <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                            data-bs-target="#faq1">
                                            ¿Cuándo debo hacer mi declaración de renta?
                                        </button>
                                    </h2>

                                    <!-- SE MUESTRA SIEMPRE -->
                                    <div class="accordion-collapse collapse show" id="faq1">
                                        <div class="accordion-body">
                                            La declaración de renta se realiza entre abril de cada año. Te ayudamos a
                                            preparar todos los documentos con anticipación para evitar contratiempos.
                                        </div>
                                    </div>
                                </div>

                                <div class="accordion-item">
                                    <h2 class="accordion-header">
                                        <button class="accordion-button collapsed" type="button"
                                            data-bs-toggle="collapse" data-bs-target="#faq2">
                                            ¿Qué documentos necesito para formalizar mi empresa?
                                        </button>
                                    </h2>
                                    <div class="accordion-collapse collapse" id="faq2">
                                        <div class="accordion-body">
                                            Necesitas tu cédula de identidad, definir el objeto social, capital inicial
                                            y socios (si los hay). Te guiamos en todo el proceso paso a paso.
                                        </div>
                                    </div>
                                </div>

                                <div class="accordion-item">
                                    <h2 class="accordion-header">
                                        <button class="accordion-button collapsed" type="button"
                                            data-bs-toggle="collapse" data-bs-target="#faq3">
                                            ¿Cuánto tiempo toma constituir una empresa?
                                        </button>
                                    </h2>
                                    <div class="accordion-collapse collapse" id="faq3">
                                        <div class="accordion-body">
                                            La constitución en "Empresa en un Día" puede estar lista en <strong>24 a 48
                                                horas hábiles</strong>. Sin embargo, la obtención del RUT y la
                                            habilitación para facturar en el SII depende de la verificación de
                                            actividades, lo cual gestionamos para que sea lo más rápido posible.
                                        </div>
                                    </div>
                                </div>

                                <div class="accordion-item">
                                    <h2 class="accordion-header">
                                        <button class="accordion-button collapsed" type="button"
                                            data-bs-toggle="collapse" data-bs-target="#faq4">
                                            ¿Necesito un contador mensual si mi empresa no vende nada?
                                        </button>
                                    </h2>
                                    <div class="accordion-collapse collapse" id="faq4">
                                        <div class="accordion-body">
                                            Aunque no tengas ventas, tienes la obligación de informar al SII
                                            mensualmente (F29 "Sin Movimiento"). Te ofrecemos planes económicos para
                                            mantener tu cumplimiento al día y evitar que se acumulen multas por olvido.
                                        </div>
                                    </div>
                                </div>

                                <div class="accordion-item">
                                    <h2 class="accordion-header">
                                        <button class="accordion-button collapsed" type="button"
                                            data-bs-toggle="collapse" data-bs-target="#faq5">
                                            ¿Qué pasa si quiero cerrar una empresa que nunca tuvo movimientos?
                                        </button>
                                    </h2>
                                    <div class="accordion-collapse collapse" id="faq5">
                                        <div class="accordion-body">
                                            Es el momento ideal para hacerlo! Un Término de Giro dentro del plazo (2
                                            meses) evita que el SII te cobre multas automáticas por no presentar
                                            declaraciones mensuales (F29) o anuales (Renta). Revisamos que no tengas
                                            deudas y cerramos el ciclo legalmente.
                                        </div>
                                    </div>
                                </div>

                                <div class="accordion-item">
                                    <h2 class="accordion-header">
                                        <button class="accordion-button collapsed" type="button"
                                            data-bs-toggle="collapse" data-bs-target="#faq6">
                                            ¿Qué métodos de pago aceptan?
                                        </button>
                                    </h2>
                                    <div class="accordion-collapse collapse" id="faq6">
                                        <div class="accordion-body">
                                            Queremos facilitarte el proceso, por lo que aceptamos transferencia
                                            electrónica y pagos con
                                            tarjeta de crédito o débito a través de nuestro portal de pago seguro. Si
                                            prefieres pagar con
                                            tarjeta de crédito, puedes incluso optar por cuotas según las condiciones de
                                            tu banco.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <!-- CONTACTO -->
            <section class="section contact__v2" id="contacto">
                <div class="container">
                    <div class="row mb-5">
                        <div class="col-md-6 col-lg-7 mx-auto text-center">
                            <span class="subtitle text-uppercase mb-3" data-aos="fade-up"
                                data-aos-delay="0">Contacto</span>
                            <h2 class="h2 fw-bold mb-3" data-aos="fade-up" data-aos-delay="0">¿Necesitas Ayuda con tus
                                Trámites?</h2>
                            <p data-aos="fade-up" data-aos-delay="100">Contáctanos hoy mismo y recibe asesoría
                                personalizada. Estamos aquí para resolver todas tus dudas tributarias y contables.</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="d-flex gap-5 flex-column">
                                <div class="d-flex align-items-start gap-3" data-aos="fade-up" data-aos-delay="0">
                                    <div class="icon d-block"><i class="bi bi-whatsapp"></i></div>
                                    <span>
                                        <span class="d-block">WhatsApp</span>
                                        <strong><a href="https://wa.me/56972521909" class="text-decoration-none">+56 9
                                                7252 1909</a></strong>
                                    </span>
                                </div>
                                <div class="d-flex align-items-start gap-3" data-aos="fade-up" data-aos-delay="200">
                                    <div class="icon d-block"><i class="bi bi-send"></i></div>
                                    <span>
                                        <span class="d-block">Email</span>
                                        <strong><a href="mailto:asesoriasderenta@gmail.com"
                                                class="text-decoration-none">asesoriasderenta@gmail.com</a></strong>
                                    </span>
                                </div>
                                <div class="d-flex align-items-start gap-3" data-aos="fade-up" data-aos-delay="300">
                                    <div class="icon d-block"><i class="bi bi-geo-alt"></i></div>
                                    <span>
                                        <span class="d-block">Dirección</span>
                                        <address class="fw-bold"><br>La Serena<br>Región de Coquimbo, Chile</address>
                                    </span>
                                </div>
                                <div class="d-flex align-items-start gap-3" data-aos="fade-up" data-aos-delay="400">
                                    <div class="icon d-block"><i class="bi bi-clock"></i></div>
                                    <span>
                                        <span class="d-block">Horario de Atención</span>
                                        <strong>Lunes a Viernes: 9:00 - 18:00<br>Sábados: 9:00 - 13:00</strong>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6" data-aos="fade-up" data-aos-delay="500">
                            <div class="contact-form-wrapper p-4 rounded-4">
                                <h3 class="mb-4">Solicita tu Consulta Gratuita</h3>
                                <form @submit.prevent="enviarWhatsApp" class="contact-form">
                                    <div class="row g-3">
                                        <div class="col-md-6">
                                            <input type="text" class="form-control" v-model="form.nombre"
                                                placeholder="Tu nombre" required>
                                        </div>
                                        <div class="col-md-6">
                                            <input type="email" class="form-control" v-model="form.email"
                                                placeholder="Tu email" required>
                                        </div>
                                        <div class="col-12">
                                            <select class="form-select" v-model="form.servicio" required>
                                                <option value="">Selecciona el servicio</option>
                                                <option value="Declaración de Renta">Declaración de Renta</option>
                                                <option value="Contabilidad Mensual">Contabilidad Mensual</option>
                                                <option value="Formalización de Empresa">Formalización de Empresa
                                                </option>
                                                <option value="Asesoría Personalizada">Asesoría Personalizada</option>
                                                <option value="Trámites SII">Trámites SII</option>
                                                <option value="Término de Giro">Término de Giro</option>
                                                <option value="Otro">Otro</option>|
                                            </select>
                                        </div>
                                        <div class="col-12">
                                            <textarea class="form-control" v-model="form.consulta" rows="4"
                                                placeholder="Cuéntanos más sobre tu consulta..."></textarea>
                                        </div>
                                        <div class="col-12">
                                            <button type="submit" class="btn btn-primary w-100">
                                                Enviar por WhatsApp
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <!-- FOOTER -->
            <footer class="footer pt-5 pb-5">
                <div class="container">
                    <div class="row justify-content-between mb-5 g-xl-5">
                        <div class="col-md-4 mb-5 mb-lg-0">
                            <h3 class="mb-3">Aviso Legal</h3>
                            <p class="mb-4">Los valores publicados corresponden a asesorías estándar. Casos que
                                requieran reconstrucción contable, defensa ante el SII por multas antiguas o
                                fiscalizaciones en curso, serán sujetos a una cotización personalizada previo análisis.
                            </p>
                        </div>
                        <div class="col-md-7">
                            <div class="row g-2">
                                <div class="col-md-6 col-lg-4 mb-4 mb-lg-0">
                                    <h3 class="mb-3">Nuestros Servicios</h3>
                                    <ul class="list-unstyled">
                                        <li><a href="#declaracion-renta">Declaración de Renta</a></li>
                                        <li><a href="#contabilidad">Contabilidad Mensual</a></li>
                                        <li><a href="#formalizacion">Formalización de Empresas</a></li>
                                        <li><a href="#tramites-sii">Trámites SII</a></li>
                                        <li><a href="#termino-giro">Término de Giro</a></li>
                                    </ul>
                                </div>
                                <div class="col-md-6 col-lg-4 mb-4 mb-lg-0 quick-contact">
                                    <h3 class="mb-3">Contacto</h3>
                                    <p class="d-flex mb-3"><i class="bi bi-geo-alt-fill me-3"></i><span>La Serena,
                                            Chile<br>Región de Coquimbo</span></p>
                                    <a class="d-flex mb-3" href="mailto:asesoriasderenta@gmail.com"><i
                                            class="bi bi-envelope-fill me-3"></i><span>asesoriasderenta@gmail.com</span></a>
                                    <a class="d-flex mb-3" href="tel:+56972521909"><i
                                            class="bi bi-telephone-fill me-3"></i><span>+56 9 7252 1909</span></a>
                                    <a class="d-flex mb-3" href="https://wa.me/56972521909"><i
                                            class="bi bi-whatsapp me-3"></i><span>WhatsApp</span></a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row credits pt-3">
                        <div class="col-xl-8 text-center text-xl-start mb-3 mb-xl-0">
                            &copy; 2026 Asesorias de renta. Todos los derechos reservados.
                            <br><small>Asesoría Legal y Tributaria en Chile.</small>
                        </div>
                        <div
                            class="col-xl-4 justify-content-start justify-content-xl-end quick-links d-flex flex-column flex-xl-row text-center text-xl-start gap-1">
                            <a href="/politica-privacidad">Política de Privacidad</a>
                            |
                            <a href="/terminos">Términos de Servicio</a>
                        </div>
                    </div>
                </div>
            </footer>

        </main>
    </div>

    <button id="back-to-top"><i class="bi bi-arrow-up-short"></i></button>

</template>

<script setup lang="ts">
import { reactive, computed, ref, watch, onMounted } from 'vue'
import { useSeoMeta } from '@/composables/useSeoMeta'
// ======================
// SEO Meta Tags
// ======================
useSeoMeta({
    title: 'Asesoría Contable en La Serena | Declaración de Renta Chile',
    meta: [
        {
            name: 'description',
            content: 'Contador Auditor de la Universidad de La Serena. Especialista en Operación Renta, contabilidad mensual y formalización de empresas en Chile. ¡Evita multas!'
        },
        {
            name: 'keywords',
            content: 'contador la serena, declaracion de renta chile, asesoría tributaria, sii chile, formalizar empresa'
        }
    ]
})
// ======================

// ======================
// Calculadora de Honorarios e IVA
// ======================
const activeTab = ref<'honorarios' | 'iva'>('honorarios')
const calcAmount = ref<number | null>(100000)
const calcYear = ref<number>(0.1525)

onMounted(() => {
  const savedAmount = localStorage.getItem('calc_amount')
  const savedYear = localStorage.getItem('calc_year')
  const savedTab = localStorage.getItem('calc_active_tab')

  if (savedAmount) calcAmount.value = Number(savedAmount)
  if (savedYear) calcYear.value = Number(savedYear)
  if (savedTab) activeTab.value = savedTab as 'honorarios' | 'iva'
})

watch([calcAmount, calcYear, activeTab], ([newAmount, newYear, newTab]) => {
  localStorage.setItem('calc_amount', newAmount?.toString() || '')
  localStorage.setItem('calc_year', newYear.toString())
  localStorage.setItem('calc_active_tab', newTab)
})

const amountNum = computed(() => {
  const val = Number(calcAmount.value)
  return isNaN(val) ? 0 : val
})

const formatCurrency = (value: number) => {
  return new Intl.NumberFormat('es-CL', { maximumFractionDigits: 0 }).format(value)
}

const h_liq_bruto = computed(() => amountNum.value / (1 - calcYear.value))
const h_liq_retencion = computed(() => h_liq_bruto.value - amountNum.value)

const h_bru_retencion = computed(() => amountNum.value * calcYear.value)
const h_bru_neto = computed(() => amountNum.value - h_bru_retencion.value)

const IVA_RATE = 0.19

const iva_net_total = computed(() => amountNum.value * (1 + IVA_RATE))
const iva_net_iva = computed(() => iva_net_total.value - amountNum.value)

const iva_inc_neto = computed(() => amountNum.value / (1 + IVA_RATE))
const iva_inc_iva = computed(() => amountNum.value - iva_inc_neto.value)
// ======================

// ======================
// Formulario de contacto
// ======================
interface FormData {
    nombre: string
    email: string
    telefono: string
    servicio: string
    consulta: string
}

const form = reactive<FormData>({
    nombre: '',
    email: '',
    telefono: '',
    servicio: '',
    consulta: ''
})

const enviarWhatsApp = () => {
    let mensaje = `¡Hola! Me contacto desde tu página web:\n\n`
    mensaje += `*Nombre:* ${form.nombre}\n`
    mensaje += `*Email:* ${form.email}\n`
    mensaje += `*Servicio:* ${form.servicio}\n\n`
    if (form.consulta) mensaje += `*Consulta:*\n${form.consulta}`

    const mensajeCodificado = encodeURIComponent(mensaje)
    const numeroWhatsApp = '56972521909'
    const urlWhatsApp = `https://wa.me/${numeroWhatsApp}?text=${mensajeCodificado}`
    window.open(urlWhatsApp, '_blank')

    // resetForm()
}

const resetForm = () => {
    form.nombre = ''
    form.email = ''
    form.telefono = ''
    form.servicio = ''
    form.consulta = ''
}
// ======================
</script>

<style scoped>

.border-warning {
    border-color: #215C5C !important;
}
</style>